/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Insects } from 'components/Insects'
import { Microalgae } from 'components/Microalgae'
import { Invitro } from 'components/Invitro'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Scroller } from 'components/Scroller'
import { BarChart } from 'components/BarChart'
import { Map } from 'components/Map2'
import { GlobalColors } from 'components/taCSScolors'
import { Menu } from 'components/Menu'
import { Link } from '@ta-interaktiv/contentbricks'
import { ChapterNavigation } from 'components/ChapterNavigation'
// TODO Set the correct article ID here
const isMobile = window.innerWidth < 711

const ARTICLE_ID = '258325375621'
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <GlobalColors />
      <div className='navwrapper'>
        <ChapterNavigation
          content={[
            { name: 'Insekten', id: 'insects' },
            { name: 'In-vitro-Fleisch', id: 'invitro' },
            { name: 'Mikroalgen', id: 'algen' }
          ]}
        />
      </div>
      <header
        className='ui vertical  very fitted  segment '
        style={{ backgroundColor: '#9BC6DE' }}
      ></header>{' '}
      <div style={{ backgroundColor: '#9BC6DE' }}>
        <div className='ui container' style={{ backgroundColor: '#9BC6DE' }}>
          <div className='ui header'>
            <h1>Was essen wir morgen?</h1>
            <h2>
              Die Welternährung ist durch den Ukraine-Krieg, die Pandemie und
              die Klimakrise gefährdeter denn je. Umso wichtiger ist es, dass
              weniger Fleisch auf unseren Tellern landet. Wir haben die Fakten
              zusammengestellt und uns an mehreren Orten in der Schweiz Lösungen
              für nachhaltigere Alternativen angeschaut.
            </h2>
          </div>
        </div>
        <div className='ui vertical segment'>
          <div className='ui text container meta'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Barbara Reye, Sandro Lochau, Alessandro Holler
              </div>
              <div className='ta updated'>Aktualisiert am 7. März 2022</div>
            </div>
          </div>
        </div>
        <div className='ui vertical segment' style={{ paddingTop: 0 }}>
          <div className='ui text container'>
            <div className='ta text' style={{ paddingTop: 0 }}>
              <Menu hide={['intro']} />

              <p>
                Russland und die Ukraine sind die Kornkammern der Erde, sie sind
                führende Exporteure von Weizen, Mais und Ölsaaten. Deshalb führt
                der Krieg neben dem grossen Leid im überfallenen Land auch zu
                Hungerkatastrophen in vielen anderen Staaten. Aus diesem Grund
                fordern jetzt mehr als{' '}
                <Link href='https://zenodo.org/record/6389348#.Yk65SG4zbqs'>
                  630 Wissenschaftler und Wissenschaftlerinnen
                </Link>{' '}
                aus verschiedenen Ländern, unseren Fleischkonsum stark
                einzuschränken und unser Ernährungssystem endlich effizienter
                und klimafreundlicher zu gestalten.
              </p>
            </div>
            {/* <Menu hide={['intro']} /> */}
          </div>
        </div>
      </div>
      <Scroller
        className='S1'
        front={[
          <div className='scrolleroverlay'>
            <p>
              Denn weltweit dienen mehr als zwei Drittel der
              landwirtschaftlichen Flächen für die Produktion von Tierfutter und
              rund ein Drittel unserer Nahrung verfüttern wir an Rinder,
              Schweine oder Geflügel. «Insgesamt wird mehr Mais von Masttieren
              als von Menschen verzehrt», gibt Johanna Jacobi, Agrarökologin an
              der ETH Zürich, zu bedenken. Hinzu kommt, dass die Viehzucht
              weltweit mit rund 15 Prozent zu den vom Menschen verursachten
              Emissionen beiträgt.
            </p>
          </div>,
          <div className='scrolleroverlay'>
            <p>
              Viele Menschen sind aber ausgeprägte Karnivoren, für die das
              Fleischessen Tradition hat. Sie wollen auf das feine Entrecôte,
              den knusprig gebratenen Pouletschenkel oder die gegrillten
              Cervelats nicht verzichten. Doch wie werden in Zukunft alle satt,
              ohne den Planeten weiter zu zerstören?
            </p>
            <p>
              Tatsache ist, dass immer mehr Menschen rund um den Globus ernährt
              werden müssen. Da die Weltbevölkerung - auch durch die relativ
              hohe Geburtsrate - stetig wächst, wird erwartet, dass im Jahr 2050
              voraussichtlich rund zwei Milliarden Menschen mehr auf dieser Erde
              leben als heute.
            </p>
          </div>
        ]}
        back={i => {
          return (
            <div className='scrollerbackground fade'>
              <div
                className='scrollerimage left'
                style={{
                  backgroundImage: `url(${require('images/intro_1.jpg')})`
                }}
              >
                <div className='source_' style={{ color: '#ffffff' }}>
                  Getty Images
                </div>
              </div>
              <div
                className='scrollerimage left'
                style={{
                  backgroundImage: `url(${require('images/intro_2.jpg')})`,
                  opacity: i === 1 ? 0 : 1
                }}
              >
                <div className='source_' style={{ color: '#ffffff' }}>
                  KEYSTONE/Ennio Leanza
                </div>
              </div>
            </div>
          )
        }}
      />
      {/* <Scroller
        className='S1'
        front={[
          <div className='scrolleroverlay'>
            <p>
              Viele Menschen sind aber ausgeprägte Karnivoren, für die das
              Fleischessen Tradition hat. Sie wollen auf das feine Entrecôte,
              den knusprig gebratenen Pouletschenkel oder die gegrillten
              Cervelats nicht verzichten. Doch wie werden in Zukunft alle satt,
              ohne den Planeten weiter zu zerstören?
            </p>
            <p>
              Tatsache ist, dass immer mehr Menschen rund um den Globus ernährt
              werden müssen. Da die Weltbevölkerung - auch durch die relativ
              hohe Geburtsrate - stetig wächst, wird erwartet, dass im Jahr 2050
              voraussichtlich rund zwei Milliarden Menschen mehr auf dieser Erde
              leben als heute.
            </p>
          </div>
        ]}
        back={i => {
          return (
            <div
              className='scrollerbackground left'
              style={{
                backgroundImage: `url(${require('images/intro_2.jpg')})`
              }}
            >
              <div className='source_' style={{ color: '#2020346' }}>
                Getty Images
              </div>
            </div>
          )
        }}
      /> */}
      <div className='ui vertical segment' id='intro'>
        <Scroller
          endSpace={isMobile ? 6 : 2}
          className='S2'
          front={[
            <div className='scrolleroverlay'>
              <div className='quote'>
                «Wir brauchen dringend neue, umweltschonende Rohstoffe und
                müssen den zu hohen Fleischkonsum jetzt reduzieren. Ansonsten
                haben wir schon bald ein Riesenproblem.»
              </div>
              <div className='author'>
                Nachhaltigkeitsforscher Alexander Mathys von der ETH Zürich
              </div>
            </div>,
            <div className='scrolleroverlay'>
              <p>
                Im Jahr 2020 lag nach Berechnungen der Ernährungs- und
                Landwirtschaftsorganisation der Vereinten Nationen (FAO) die
                weltweite Produktionsmenge bei insgesamt 337,2 Millionen Tonnen
                Fleisch.
              </p>
            </div>,
            <div className='scrolleroverlay'>
              <p>
                {' '}
                <BarChart
                  title={'Fleischkonsum'}
                  sub={'in Kilogramm pro Person und Jahr'}
                  highlighted={['Schweiz']}
                  max={100}
                  source={
                    <>
                      <a href='https://www.proviande.ch/sites/proviande/files/2020-05/Der%20Fleischmarkt%20im%20%C3%9Cberblick%20-%20Aktuelle%20Ausgabe.pdf'>
                        Proviande
                      </a>{' '}
                      ,FAO 2018
                    </>
                  }
                  data={[
                    { n: 'Ozeanien', v: 83 },
                    { n: 'Amerika', v: 73 },
                    { n: 'Europa', v: 61 },
                    { n: 'Asien', v: 26 },
                    { n: 'Afrika', v: 14 },
                    { n: 'Schweiz', v: 52 },
                    { n: 'Weltweit', v: 34 }
                  ]}
                />
              </p>
              <p>
                Allein in der Schweiz landen im Durchschnitt pro Person jedes
                Jahr rund 51 Kilogramm Fleisch auf dem Teller, in den USA und in
                Australien dagegen mehr als 100 Kilogramm und in den sich
                entwickelnden Ländern im Durchschnitt knapp 27 Kilogramm.
              </p>
            </div>
          ]}
          back={i => {
            return (
              <div className='scrollerbackground'>
                <Map step={1} blink />
                <div
                  className='scrollerimage center'
                  style={{
                    zIndex: 1000,
                    backgroundImage: `url(${require('images/intro_3.jpg')})`,
                    opacity: i >= 1 ? 1 : 0
                  }}
                >
                  <div className='source_' style={{ color: '#ffffff' }}>
                    KEYSTONE/Gaetan Bally
                  </div>
                </div>
              </div>
            )
          }}
        />
        {/* <Scroller
          className='S3'
          front={[
            <div className='scrolleroverlay'>
              <p>
                Im Jahr 2020 lag nach Berechnungen der Ernährungs- und
                Landwirtschaftsorganisation der Vereinten Nationen (FAO) die
                weltweite Produktionsmenge bei insgesamt 337,2 Millionen Tonnen
                Fleisch.
              </p>
            </div>,
            <div className='scrolleroverlay'>
              <p>
                {' '}
                <BarChart
                  title={'Fleischkonsum'}
                  sub={'in Kilogramm pro Person und Jahr'}
                  highlighted={['Schweiz']}
                  max={100}
                  source={
                    <>
                      <a href='https://www.proviande.ch/sites/proviande/files/2020-05/Der%20Fleischmarkt%20im%20%C3%9Cberblick%20-%20Aktuelle%20Ausgabe.pdf'>
                        Proviande
                      </a>{' '}
                      ,FAO 2018
                    </>
                  }
                  data={[
                    { n: 'Ozeanien', v: 83 },
                    { n: 'Amerika', v: 73 },
                    { n: 'Europa', v: 61 },
                    { n: 'Asien', v: 26 },
                    { n: 'Afrika', v: 14 },
                    { n: 'Schweiz', v: 52 },
                    { n: 'Weltweit', v: 34 }
                  ]}
                />
              </p>
              <p>
                Allein in der Schweiz landen im Durchschnitt pro Person jedes
                Jahr rund 51 Kilogramm Fleisch auf dem Teller, in den USA und in
                Australien dagegen mehr als 100 Kilogramm und in den sich
                entwickelnden Ländern im Durchschnitt knapp 27 Kilogramm.
              </p>
            </div>
          ]}
          back={i => (
            <div
              className='scrollerbackground'
              style={{
                backgroundImage: `url(${require('images/intro_3.jpg')})`
              }}
            ></div>
          )}
        /> */}
        <Scroller
          className='S2'
          front={[
            <div className='scrolleroverlay empty' />,
            <div className='scrolleroverlay'>
              <p>
                Weil der Konsum von Fleisch oft auch als Symbol für Wohlstand
                und Status gilt, wird vor allem in Schwellen- und
                Entwicklungsländern die Nachfrage stark zunehmen. Dennoch findet
                in einigen Industrieländern ein Umdenken statt – vor allem auch
                in der Schweiz.
              </p>
              <p>
                So sind hierzulande Fleischersatzprodukte in den vergangenen
                Jahren immer beliebter geworden. Gemäss dem Bundesamt für
                Landwirtschaft (BLW) war 2020 sogar jeder sechste Burger nicht
                mehr aus «echtem» Fleisch, sondern auf Pflanzenbasis
                hergestellt.
              </p>
              <p>
                Mit neuen Foodkreationen suchen auch bei uns Hochschulen und
                Start-ups nach innovativen Ansätzen, um den durchschnittlichen
                Fleischkonsum weiter zu reduzieren. Ganz nach dem Motto: Je
                besser dies gelingt, umso besser für die Öko-Bilanz.
              </p>
            </div>,

            <div className='scrolleroverlay'>
              <p>
                Im <b>Aargau und in Linthal</b> werden deshalb Insekten als
                alternative Proteinquelle gezüchtet, …
              </p>
            </div>,
            <div className='scrolleroverlay'>
              <p>
                in <b>Wädenswil</b> Laborfleisch entwickelt und …
              </p>
            </div>,
            <div className='scrolleroverlay'>
              <p>
                … in <b>Zürich</b> an Mikroalgen geforscht, die eines Tages in
                grossen Biotanks oder an Häuserfassaden gedeihen sollen.
              </p>
            </div>
          ]}
          back={i => <Map step={i} />}
        />
        {/* <div className='ui text container'>
          <Menu hide={['insects']} small />
        </div> */}
        <Insects />

        <Invitro />

        <Microalgae />
      </div>
      <div style={{ clear: 'both' }} />
      <Footer
        articleId={ARTICLE_ID}
        hidePortfolioTeaser
        questions={[
          'Wie informativ war der Beitrag?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          [
            'Zum Projekt',
            'Dieses Multimedia-Projekt wurde vom Schweizer Klub für Wissenschafts&shy;journalismus (SKWJ) und der Gebert Rüf Stiftung (GRS) ausgewählt und unterstützt, um durch die Zusammenarbeit zwischen Journalist*innen und Absolvent*innen des Studiengangs «Knowledge Visualization» der Zürcher Hochschule der Künste (ZHdK) neue Erzählformen für den Wissenschaftsjournalismus zu finden.'
          ],
          ['Recherche, Konzept, Text', 'Barbara Reye'],
          [
            'Visuelle Gestaltung, Illustrationen und Interaktionskonzept',
            'Sandro Lochau, Alessandro Holler (Quaint GmbH)'
          ],
          ['Programmierung', 'Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
